<template>
    <div class="modal fade share-bet-modal" id="qrPreviewModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <button type="button" class="cross_btn_top" data-bs-dismiss="modal" aria-label="Close">&#10006;</button>
                <div class="modal-body">
                    <section class="sub-header-wrapper text-white">
                        <div class="qrPreview-image">
                            <figure v-if="showQrCode">
                                <img loading="lazy" :src="qrCode" alt="QR-Code">
                            </figure>
                            <div v-else class="text-center">
                                <qrcode-canvas v-if="qrCode" :value="qrCode" level="H" id="qrCanvas" />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { QrcodeCanvas } from 'qrcode.vue'
export default {
    name: 'qrCodeModal',
    components:{QrcodeCanvas},
    props: ['qrCode','showQrCode']
}
</script>